import { IPreviewOptions } from '@/types/components/preview';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SETTING_TYPE } from '@/constants/enum';

const previewOptionInitial: IPreviewOptions = {
  methods: [
    { key: SETTING_TYPE.SHIPPING, isEnable: true, selected: true },
    { key: SETTING_TYPE.DELIVERY, isEnable: true, selected: false },
    { key: SETTING_TYPE.PICKUP, isEnable: true, selected: false },
  ],
  inputPostalCode: '',
  errorPostalCode: true,
  isChecking: false,
};

const initialState = {
  previewOption: previewOptionInitial,
  previewOptionBackup: previewOptionInitial,
};

const previewOptionSlice = createSlice({
  name: 'previewOption',
  initialState,
  reducers: {
    handleSavePreviewOptionSettings: (state, action: PayloadAction<Partial<IPreviewOptions>>) => {
      state.previewOption = { ...state.previewOption, ...action.payload };
    },
    handleSaveBackupPreviewOptionSettings: (state, action: PayloadAction<Partial<IPreviewOptions>>) => {
      state.previewOptionBackup = { ...state.previewOptionBackup, ...action.payload };
    },
  },
});

export const previewOptionSelector = createSelector(
  (state: RootState) => state.previewOption,
  (state) => state.previewOption,
);

export const { handleSavePreviewOptionSettings, handleSaveBackupPreviewOptionSettings } = previewOptionSlice.actions;

export default previewOptionSlice;
